import WrapperRouter from "./helpers/router";
import "./components/tinymce/tinymce.css";
import Login from "./pages/auth/login";
import ForgotPassword from "./pages/auth/forgotPassword";
import EnterMail from "./pages/auth/enterMail";
import ResetPassword from "./pages/auth/resetPassword";
import Dashboard from "./components/dashboard/layout";
import Content from "./components/dashboard/content";
import UsersPage from "./pages/admin/users";
import Department from "./pages/admin/department";
import Unit from "./pages/admin/unit";
import BudgetItem from "./pages/admin/budgetitem";
import Budgets from "./pages/admin/budgets";
import FinalAccounts from "./pages/admin/finalAccounts";
import FinancialYear from "./pages/admin/year";
import Profile from "./pages/admin/profile";
import VoucherConfig from "./pages/admin/voucherConfig";
import Voucher from "./pages/admin/voucher";
import Memo from "./pages/admin/memo";
import MemoRecommendation from "./pages/admin/memoRecommendation";
import TaxConfig from "./pages/admin/taxes";
import VoucherApprovalStage from "./pages/admin/voucherApprovalStages";
import Payroll from "./pages/admin/payroll";
import PayrollApproval from "./pages/admin/payrollApproval";
import BudgetApproval from "./pages/admin/budgetAppproval";
import RefreshContext from "./context/refreshContext";
import Step from "./pages/admin/step";
import Level from "./pages/admin/level";
import Benefit from "./pages/admin/benefit";
import Deduction from "./pages/admin/deduction";
import PayrollConfig from "./pages/admin/payrollConfig";
import BudgetCategory from "./pages/admin/budgetCategory";
import StaffCategory from "./pages/admin/staffCategory";
import StaffProjection from "./pages/admin/staffProjection";
import Designation from "./pages/admin/designation";
import Store from "./pages/admin/store";
import StoreDepartment from "./pages/admin/storeDepartment";
import Category from "./pages/admin/category";
import Item from "./pages/admin/item";
import StoreTransactions from "./pages/admin/storeTransactions";
import { Route } from "react-router-dom";
import { useState } from "react";

function App() {
  const [flag, setFlag] = useState(false);

  return (
    <RefreshContext.Provider value={{ flag, setFlag }}>
      <WrapperRouter basename={"/"}>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password">
          <Route path="" element={<EnterMail />} index />
          <Route path="confirm" element={<ForgotPassword />} />
          <Route path="reset" element={<ResetPassword />} />
        </Route>
        <Route path="/dashboard" element={<Dashboard />}>
          <Route path="" index element={<Content />} />
          <Route path="users" element={<UsersPage />} />
          <Route path="department" element={<Department />} />
          <Route path="unit" element={<Unit />} />
          <Route path="subaccount-type" element={<BudgetItem />} />
          <Route path="budgets" element={<Budgets />} />
          <Route path="final-accounts" element={<FinalAccounts />} />
          <Route path="financial-year" element={<FinancialYear />} />
          <Route path="profile" element={<Profile />} />
          <Route path="voucher-config" element={<VoucherConfig />} />
          <Route path="voucher" element={<Voucher />} />
          <Route path="memo/manage/memo" element={<Memo />} />
          <Route path="memo/recommendation" element={<MemoRecommendation />} />
          <Route path="step" element={<Step />} />
          <Route path="level" element={<Level />} />
          <Route path="benefit" element={<Benefit />} />
          <Route path="deduction" element={<Deduction />} />
          <Route path="voucher-approval" element={<VoucherApprovalStage />} />
          <Route path="tax-config" element={<TaxConfig />} />
          <Route path="payroll" element={<Payroll />} />
          <Route path="payroll-approval" element={<PayrollApproval />} />
          <Route path="payroll-config" element={<PayrollConfig />} />
          <Route path="budget-approval" element={<BudgetApproval />} />
          <Route path="budget-category" element={<BudgetCategory />}></Route>
          <Route path="staff-category" element={<StaffCategory />}></Route>
          <Route path="staff-projection" element={<StaffProjection />}></Route>
          <Route path="designation" element={<Designation />}></Route>
          <Route path="store" element={<Store />}></Route>
          <Route path="store-department" element={<StoreDepartment />}></Route>
          <Route path="category" element={<Category />}></Route>
          <Route path="item" element={<Item />}></Route>
          <Route path="store-transactions" element={<StoreTransactions />}></Route>
        </Route>
      </WrapperRouter>
    </RefreshContext.Provider>
  );
}

export default App;
